import { MessageOutlined, ShareAltOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GroupPrivateSetting, RequestedPostFragment } from '@/generated/graphql'
import { PostEditor } from '@/modules/post/post-editor'

import { PostLike } from '../post-like'
import s from './post-card.module.less'

interface PostCardActionProps {
  post: RequestedPostFragment
  disableActionText?: boolean
  onClickComment: () => void
}

export const PostCardAction: React.FC<PostCardActionProps> = ({ post, onClickComment, disableActionText = false }) => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const [t] = useTranslation()
  const [visible, setVisible] = React.useState(false)

  if (post.archivedAt) {
    return null
  }

  const onFocusTextarea = () => {
    onClickComment()
    window.setTimeout(() => {
      const textareas = containerRef.current?.parentNode?.querySelectorAll('textarea')
      if (textareas?.length) {
        textareas[textareas.length - 1].focus()
      }
    }, 0)
  }

  return (
    <div className={s.actionsContainer} ref={containerRef}>
      <PostLike post={post} disableActionText={disableActionText} />

      <div onClick={onFocusTextarea}>
        <MessageOutlined />
        {!disableActionText && t('post.comment')}
      </div>

      {post.group?.privateSetting !== GroupPrivateSetting.Closed && (
        <div onClick={() => setVisible(true)}>
          <ShareAltOutlined /> {!disableActionText && t('post.share')}
        </div>
      )}
      <PostEditor
        showGroupSelector
        isShare
        groupId={1}
        post={post}
        visible={visible}
        onClose={() => setVisible(false)}
      />
    </div>
  )
}
